import React, { useEffect, useState } from 'react';
// import Main from '../components/layout/Main';
import axios from 'axios';
import { Button, DatePicker, Input, Radio, Tooltip, message } from 'antd';
import { useLocation } from 'react-router-dom';
import AdminProfile from './AdminProfile';
import { CSVLink } from 'react-csv';
import NewTransactionTable from './NewTransactionTable';
import Model from './Model';
import { format } from 'date-fns';

const { Search } = Input;
const { RangePicker } = DatePicker;

function SubscriptionTrans(props) {
    const { userName, formSubmitted, FilterValue } = props;
    const [totalPages, setTotalPages] = useState(0);
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(50);
    const [data, setData] = useState([]);
    const [data1, setData1] = useState([]);
    const [statusFilterValue, setStatusFilterValue] = useState("TRADE");
    const [levelFilter, setLevelFilter] = useState(null);
    const [UsernameFilter, setUsernameFilter] = useState(null);
    const [dateFilter, setdateFilter] = useState(null);
    const [TransidFilter, setTransidFilter] = useState(null);
    const location = useLocation();
    const { profile } = AdminProfile()
    const [profileAvatar, setProfileAvatar] = useState(profile?.Adminname);
    const [gatewayFilter, setGatewayFilter] = useState(null);
    const [assetsFilter, setAssetsFilter] = useState(null);
    const [searchType, setSearchType] = useState(1);
    const [placeholder, setPlaceholder] = useState('Search Username...');
    const jwt = localStorage.getItem('jwt');
    const [dataDetails, setDataDetails] = useState([]);

    useEffect(() => {
        setProfileAvatar(profile?.Adminname);
    }, [profile]);

    const handleStatusFilter = (pack) => {
        setStatusFilterValue(pack);
    };

    const ViewTotalLevel = (statusFilterValue, usernameValue, form_by, datefilter, transidValue) => {
        const jwt = localStorage.getItem('jwt');

        const postData = {
            jwt: jwt,
            page_no: page,
            page_size: size,
            pack: ["BOT"]
        };

        if (location.pathname === '/UpdateUser' || location.pathname === '/UpdateUsers' || location.pathname === '/dashboard/activeuser' || location.pathname === '/dashboard/activeuser') {
            postData.username = [userName];
        }

        if (datefilter !== null && datefilter.length > 0) {
            postData.date = datefilter;
        }

        if (location.pathname === '/dashboard/activeuser') {
            postData.pack = [FilterValue];
        } else if (statusFilterValue !== null && statusFilterValue !== undefined) {
            postData.pack = [statusFilterValue];
        }

        if (form_by !== null && form_by !== undefined) {
            postData.by = [form_by]
        }
        if (usernameValue !== null && usernameValue !== undefined) {
            if (/^\d+$/.test(usernameValue)) {
                postData.transid = [usernameValue];
            } else {
                postData.username = [usernameValue];
            }
        }

        if (transidValue !== null && transidValue !== undefined) {
            postData.transid = [transidValue];
        }

        axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            url: process.env.REACT_APP_API + '/user/total_page_subscription_qualification',
            data: postData
        }).then(res => {
            setTotalPages(res?.data?.Success);
            // props.formSubmitted(totalPages)
        }).catch(err => {
            console.log(err);
        });
    };

    const ViewLevel = (statusFilterValue, usernameValue, form_by, datefilter, transidValue) => {
        const jwt = localStorage.getItem('jwt');

        const postData = {
            jwt: jwt,
            page_no: page,
            page_size: size,
            pack: ["BOT"]
            // username: location.pathname === '/UpdateUser' ? [userName] : [userName],
            // by: location.pathname === '/UpdateUser' || location.pathname === '/UpdateUsers' ? [profileAvatar] : ""

            // by: [profileAvatar, "User"]
        };
        if (location.pathname === '/UpdateUser' || location.pathname === '/UpdateUsers' || location.pathname === '/dashboard/activeuser' || location.pathname === '/dashboard/activeuser') {
            postData.username = [userName];
        }

        if (datefilter !== null && datefilter.length > 0) {
            postData.date = datefilter;
        }

        // if (location.pathname === '/dashboard/activeuser') {
        //     postData.pack = [FilterValue];
        // } else if (statusFilterValue !== null && statusFilterValue !== undefined) {
        //     postData.pack = [statusFilterValue];
        // }


        if (form_by !== null && form_by !== undefined) {
            postData.by = [form_by]
        }
        if (usernameValue !== null && usernameValue !== undefined) {
            if (/^\d+$/.test(usernameValue)) {
                postData.transid = [usernameValue];
            } else {
                postData.username = [usernameValue];
            }
        }

        if (transidValue !== null && transidValue !== undefined) {
            postData.transid = [transidValue];
        }

        axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            url: process.env.REACT_APP_API + '/user/subscription_qualification',
            data: postData
        }).then(res => {
            if (res?.data?.Success === "No transactions yet!") {
                setData([]);
                // message.info("No transactions yet!");
            } else {
                setData(res?.data?.Success);
                // props.formSubmitted(data)
            }
        }).catch(err => {
            // message.error(err);
        });
    };

    const ViewBotDetails = () => {

        const postData = {
            jwt: jwt,
            username: userName
        };

        axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            url: process.env.REACT_APP_API + '/user/user_subscription_details',
            data: postData
        }).then(res => {
            const data = res?.data?.Success;
            setDataDetails(data);
        }).catch(err => {
            message.error(err);
        });
    };

    useEffect(() => {
        if (userName) {
            ViewBotDetails();
            ViewTotalLevel(statusFilterValue, UsernameFilter, gatewayFilter, dateFilter, TransidFilter, FilterValue);
            ViewLevel(statusFilterValue, UsernameFilter, gatewayFilter, dateFilter, TransidFilter, FilterValue);
        }
    }, [page, size, statusFilterValue, formSubmitted, dateFilter, FilterValue, UsernameFilter, TransidFilter, gatewayFilter, assetsFilter, userName]);

    const [selectedUsername, setSelectedUsername] = useState('');
    const [selectedTransID, setSelectedTransID] = useState('');

    const columns = [
        {
            title: "Datetime",
            dataIndex: "DateTime",
            key: "DateTime",
            width: undefined,
            className: "whitespace-nowrap ",
        },
        {
            title: "Trans ID",
            dataIndex: "Trans_ID",
            key: "Trans_ID",
            width: undefined,
            className: "whitespace-nowrap ",
        },
        // {
        //     title: "Name",
        //     dataIndex: "Name",
        //     key: "Name",
        // },
        // {
        //     title: <Tooltip title="Direct Bonus" className='cursor-pointer'>DB</Tooltip>,
        //     dataIndex: "Commission_Distribution",
        //     key: "Commission_Distribution",
        // },

        {
            title: 'Package Value',
            dataIndex: 'Name',
            key: 'Name',
            width: undefined,
            className: "whitespace-nowrap ",
        },

        // {
        //     title: 'Bought Using',
        //     dataIndex: 'Bought_Using',
        //     key: 'Bought_Using',
        // },
        {
            title: 'Executed By',
            dataIndex: 'Executed_By',
            key: 'Executed_By',
            width: undefined,
            className: "whitespace-nowrap ",
        },

        {
            title: 'Validity',
            dataIndex: 'Validity',
            key: 'Validity',
            width: undefined,
            className: "whitespace-nowrap ",
        },
        {
            title: 'STATUS',
            dataIndex: 'Status',
            key: 'Status',
            render: (text, record) => {
                return text === "Active" ? (
                    <button
                        onClick={() => showModal(record.Username, record.Trans_ID)}
                        className='text-[#008000] px-3 rounded-xl'
                    >
                        {text}
                    </button>
                ) : (
                    <button
                        className='text-[rgb(255,0,0)] px-3 rounded-xl'
                    >
                        {text}
                    </button>
                );
            },
        }

    ];

    const showModal = (username, transID) => {
        setEditModal(true);
        // Save these parameters in state if needed
        setSelectedUsername(username);
        setSelectedTransID(transID);
    };


    const [editModal, setEditModal] = useState(false);

    const handleModalClose = () => {
        setEditModal(false);
    };

    const handleApproveReject = (values) => {
        const jwt = localStorage.getItem('jwt');
        console.log("Username: ", selectedUsername); // Debugging line
        console.log("Subscription ID: ", selectedTransID); // Debugging line
        const postData = {
            jwt: jwt,
            username: selectedUsername.props.title,
            totp: values?.totp,
            subscriptionid: selectedTransID,
        };

        axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            url: process.env.REACT_APP_API + '/subscription/expiry_subscription',
            data: postData
        }).then(response => {
            message.success(response?.data?.Success);
            handleModalClose();
            ViewTotalLevel(statusFilterValue, UsernameFilter, gatewayFilter, TransidFilter);
            ViewLevel(statusFilterValue, UsernameFilter, gatewayFilter, TransidFilter);
        }).catch(err => {
            message.error(err.response?.data?.Error);
        });
    };


    const handleLevelFilter = (value) => {
        setLevelFilter(value);
    };


    const dataSource = data.map((item, index) => ({
        Serial: index + 1,
        DateTime: item?.DateTime,
        Trans_ID: item?.Trans_ID,
        Username: (
            item?.Username ? (
                <Tooltip className='text-xs cursor-pointer' title={item.Username}>
                    <div>
                        {item.Username.length > 7
                            ? `${item.Username.slice(0, 6)}...${item.Username.slice(-4)}`
                            : item.Username
                        }
                    </div>
                </Tooltip>
            ) : null
        ),
        Name: item?.Name,
        Executed_By: item?.Executed_By,
        Validity: Math.floor(item?.Validity / 7) + " week/s",
        Status: item?.Status ? "Active" : "Expired",
    }));



    const handleSearch = (value) => {
        const searchValue = value.trim();
        switch (searchType) {
            case 1:
                setUsernameFilter(searchValue);
                setTransidFilter(null);
                setGatewayFilter(null);
                break;
            case 2:
                setUsernameFilter(null);
                setTransidFilter(searchValue);
                setGatewayFilter(null);
                break;
            case 3:
                setUsernameFilter(null);
                setTransidFilter(null);
                setGatewayFilter(searchValue);
                break;
            case 4:
                setUsernameFilter(null);
                setTransidFilter(null);
                setGatewayFilter(null);
                setdateFilter(searchValue);
                break;
            default:
                break;
        }
    };

    const onChange = e => {
        setSearchType(e.target.value);
        switch (e.target.value) {
            case 1:
                setPlaceholder('Search Username...');
                break;
            case 2:
                setPlaceholder('Search Transaction ID...');
                break;
            case 3:
                setPlaceholder('Search Executed By...');
                break;
            default:
                setPlaceholder('Search...');
        }
    };


    const prepareDataForCSV = () => {
        const csvData = Array.isArray(data) ? data.map((item, index) => ({
            Serial: index + 1,
            DateTime: item?.DateTime || "--",
            Trans_ID: item?.Trans_ID || "--",
            Username: item?.Username || "--",
            Name: item?.Name || "--",
            Executed_By: item?.Executed_By || "--",
            Validity: Math.floor(item?.Validity / 7) + " week/s" || "--",
            Status: item?.Status ? "Active" : "Expired" || "--"
        })) : [];

        return csvData;
    };

    const handleDateChange = (dates) => {
        if (dates && dates[0] && dates[1]) {
            const formattedDates = dates.map(date => date.toDate()).map(date => format(date, 'dd-MM-yyyy'));
            setdateFilter(formattedDates);
        } else {
            setdateFilter(null);
        }
    };

    const renderSubscriptionDetails = (subscriptionData) => {
        if (!subscriptionData) return null;
        const details = [
            { label: "Number of Exchanges", value: subscriptionData.Number_of_Exchange },
            { label: "Active Subscriptions", value: subscriptionData.Active_Subscription },
            { label: "Inactive Subscriptions", value: subscriptionData.Inactive_Subscription },
            { label: "Active Subscription Volume", value: subscriptionData.Active_Subscription_Volume },
            { label: "Inactive Subscription Volume", value: subscriptionData.Inactive_Subscription_Volume },
            { label: "APIs Allowed (LIVE)", value: subscriptionData.Number_of_APIs_Allowed_LIVE },
            { label: "Bots Allowed (LIVE)", value: subscriptionData.Number_of_Bots_Allowed_LIVE },
            { label: "APIs Allowed (PAPER)", value: subscriptionData.Number_of_APIs_Allowed_PAPER },
            { label: "Bots Allowed (PAPER)", value: subscriptionData.Number_of_Bots_Allowed_PAPER },
            { label: "Max Fund Allowed", value: subscriptionData.Max_Fund_Allowed },
        ];

        return (
            <div>
                <h2 className="text-lg font-bold mb-4">Subscription Details</h2>
                <div className="grid grid-cols-5 gap-4">
                    {details.map((item, index) => (
                        <div
                            key={index}
                            className="border flex justify-between items-center border-gray-300 rounded-lg shadow-md p-2 bg-white"
                        >
                            <h3 className="text-xs font-semibold text-gray-600">{item.label}</h3>
                            <p className="text-sm font-bold text-gray-800">{item.value}</p>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    return (

        location.pathname === '/dashboard/activeuser' || location.pathname === '/dashboard/activeuser' ? (
            <div >
                <div>
                    {renderSubscriptionDetails(dataDetails?.[0])} {/* Assuming the data is in an array */}
                </div>

                <div>
                    <div className='block md:flex gap-2 justify-between items-center my-2'>


                        <RangePicker format={'DD-MM-YYYY'}
                            onChange={handleDateChange} />
                        <div className='flex justify-end gap-5 items-center'>

                            <div className=''>
                                <Button className='bg-colorAccent text-white px-4  font-semibold rounded-lg' >
                                    <CSVLink
                                        data={prepareDataForCSV()}
                                        filename={'user_data.csv'}
                                        className="text-white"
                                    >
                                        Download CSV
                                    </CSVLink>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <Model
                        title="Expiry Subscription"
                        open={editModal}
                        onCancel={handleModalClose}
                        onFinish={handleApproveReject}
                        label2="2FA"
                        name2="totp"
                        placeholder2="Enter 2FA"
                        message2="Please input your 2FA!"
                    />
                </div>
                <NewTransactionTable data={data} handleSearch={handleSearch} prepareDataForCSV={prepareDataForCSV} onSearch={handleSearch} setData={setData} onLevelChange={handleLevelFilter} columns={columns} dataSource={dataSource} totalPages={totalPages} page={page} size={size} setPage={setPage} setSize={setSize} />
            </div>
        ) : (
            <>
                <div className='mx-0 md:mx-4 bg-white shadow-md shadow-black rounded-xl p-2  md:p-4 '>

                    <div>
                        <div className='block md:flex justify-between items-center my-2'>

                            <Radio.Group onChange={onChange} value={searchType} className='flex justify-center items'>
                                <Radio value={1} className='text-xs md:text-base'>Username</Radio>
                                <Radio value={2} className='text-xs md:text-base'>TransID</Radio>
                                <Radio value={3} className='text-xs md:text-base'>Executed By</Radio>
                            </Radio.Group>

                            <Search className=' md:w-96 my-2 md:my-0' placeholder={placeholder}
                                onSearch={handleSearch} enterButton />
                            <RangePicker format={'DD-MM-YYYY'}
                                onChange={handleDateChange} />
                            <div className='flex justify-end gap-5 items-center'>
                                <div className=''>
                                    <Button className='bg-colorAccent text-white px-4  font-semibold rounded-lg' >
                                        <CSVLink
                                            data={prepareDataForCSV()}
                                            filename={'user_data.csv'}
                                            className="text-white"
                                        >
                                            Download CSV
                                        </CSVLink>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>

                    </div>
                    <NewTransactionTable data={data} handleSearch={handleSearch} prepareDataForCSV={prepareDataForCSV} onSearch={handleSearch} setData={setData} onLevelChange={handleLevelFilter} columns={columns} dataSource={dataSource} totalPages={totalPages} page={page} size={size} setPage={setPage} setSize={setSize} />
                </div>
                <Model
                    title="Expiry Subscription"
                    open={editModal}
                    onCancel={handleModalClose}
                    onFinish={handleApproveReject}
                    label2="2FA"
                    name2="totp"
                    placeholder2="Enter 2FA"
                    message2="Please input your 2FA!"
                />
            </>


        )
    );

}

export default SubscriptionTrans;
